/**
 * Hook: čita/piše prefs u localStorage i poziva applyToDocument pri svakoj promeni.
 * Koristi ga AccessibilityPanel; može i host ako gradi sopstveni UI.
 */

import { useCallback, useEffect, useMemo, useState } from 'react';
import { DEFAULTS } from '../core/constants';
import { applyToDocument, mergeConfig, readPrefs, writePrefs } from '../core/prefs';

export function useAccessibilityPreferences(config) {
  const mergedConfig = useMemo(() => mergeConfig(config), [config]);

  const [prefs, setPrefsState] = useState(() => readPrefs(mergedConfig));

  const setPrefs = useCallback(
    (updater) => {
      setPrefsState((prev) => {
        const next = typeof updater === 'function' ? updater(prev) : updater;
        writePrefs(next, mergedConfig);
        applyToDocument(next, mergedConfig);
        return next;
      });
    },
    [mergedConfig],
  );

  const reset = useCallback(() => {
    const d = { ...DEFAULTS };
    writePrefs(d, mergedConfig);
    applyToDocument(d, mergedConfig);
    setPrefsState(d);
  }, [mergedConfig]);

  /* Pri promeni config (npr. storageKey) ponovo primeni trenutne prefs na dokument. */
  useEffect(() => {
    applyToDocument(prefs, mergedConfig);
  }, [mergedConfig]); // eslint-disable-line react-hooks/exhaustive-deps

  return { prefs, setPrefs, reset, config: mergedConfig };
}
